import ClapprHLS from '@clappr/hlsjs-playback'
import HLSJS from 'hls.js'
import {type Options} from '@clappr/core'
import {Events} from 'common/types/events'
import {isSearchBot} from 'utils/browser'
import {hasAudio} from 'utils/media'

const listContainsIgnoreCase = (item?: string, items?: string[]): boolean => {
  if (item === undefined || items === undefined) {
    return false
  }

  return (
    items.filter((itemEach) => item.toLowerCase() === itemEach.toLowerCase())
      .length > 0
  )
}

export class HLS<T extends Options> extends ClapprHLS<T> {
  private _hasAudio: boolean | undefined

  public get hasAudio(): boolean | undefined {
    return this._hasAudio
  }

  public set hasAudio(value: boolean) {
    this._hasAudio = value
  }

  static canPlay(resource: string, mimeType?: string): boolean {
    const resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || []
    const isHls =
      (resourceParts.length > 1 && resourceParts[1].toLowerCase() === 'm3u8') ||
      listContainsIgnoreCase(mimeType, [
        'application/vnd.apple.mpegurl',
        'application/x-mpegURL'
      ])
    // eslint-disable-next-line import/no-named-as-default-member
    const isSupported = HLSJS.isSupported() || isSearchBot

    return !!(isSupported && isHls)
  }

  public _onLoadedData(e: Event): void {
    super._onLoadedData(e)
    this.hasAudio ??= hasAudio(this.el) as boolean
    this.trigger(Events.PLAYBACK_LOADEDDATA)
  }

  private playTimeout?: number

  private clearPlayTimeout(): void {
    clearTimeout(this.playTimeout)
  }

  public play(): void {
    // NOTE: prevent preload when start preroll
    this.playTimeout = window.setTimeout(() => super.play(), 0)
    this.trigger(Events.PLAYBACK_PLAY_INTENT)
  }

  public pause(): void {
    this.clearPlayTimeout()
    super.pause()
  }

  public stop(): void {
    this.clearPlayTimeout()
    super.stop()
  }

  public configure(options: T): void {
    this.clearPlayTimeout()
    super.configure(options)
  }

  public destroy(): void {
    this.clearPlayTimeout()
    super.destroy()
  }
}
